import { Component, EventEmitter, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { CropperSettings, ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { ContactDialogComponent } from 'src/app/modules/contact/dialogs/contact-dialog/contact-dialog.component';

@Component({
	selector: 'app-image-cropper-dialog',
	templateUrl: './image-cropper-dialog.component.html',
	styleUrls: ['./image-cropper-dialog.component.scss']
})
export class ImageCropperDialogComponent {

	imageChangedEvent : any;
	minWidth! : number;
	minHeight! : number;
	keepAspectRatio! : boolean;
	rounded! : boolean;
	resizeToMinimumWidth? : number;

	baseContainerHeight = 600;
	baseContainerWidth = 600;
	containerHeight! : number;
	containerWidth! : number;
	croppedImage! : Blob|null|undefined;

	@HostListener('window:resize') onResizeHandler() : void {
		if (window.innerWidth < this.baseContainerWidth + 110)
			this.containerWidth = window.innerWidth - 110;
		else
			this.containerWidth = this.baseContainerWidth;

		if (window.innerHeight < this.baseContainerHeight + 240)
			this.containerHeight = window.innerHeight - 240;
		else
			this.containerHeight = this.baseContainerHeight;
	}

	constructor(private selfDialogRef: MatDialogRef<ContactDialogComponent>) {
		this.onResizeHandler();
	}
	set(event:any, minWidth:number, minHeight:number, keepAspectRatio:boolean, rounded:boolean, resizeToMinimumWidth?:number) {
		this.imageChangedEvent = event;
		this.minWidth = minWidth;
		this.minHeight = minHeight;
		this.keepAspectRatio = keepAspectRatio;
		this.rounded = rounded;
		this.resizeToMinimumWidth = resizeToMinimumWidth;
	}

	imageCropped(event: ImageCroppedEvent) {
		this.croppedImage = event.blob;
	}
	accept() {
		this.selfDialogRef.close(this.croppedImage);
	}
}
